import {ApolloClient} from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {createHttpLink} from 'apollo-link-http';

let client;

const createApolloClient = (sitename) =>
    new ApolloClient({
        cache: new InMemoryCache({addTypename: true}),
        link: createHttpLink({
            uri: '/l/graphql',
            credentials: 'same-origin',
            headers: {
                'client-name': 'static-origin-server',
                'client-version': '0.1.0',
                'x-homeaway-site': sitename,
            },
        }),
    });

const getApolloClient = (sitename) => {
    if (!client) {
        client = createApolloClient(sitename);
    }

    return client;
};

export default getApolloClient;
